module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daisy Goodwin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Daisy Goodwin studied nineteenth-century history at university and has been using it ever since. She has written two bestselling novels set in the Victorian era, "), _c('I', [_vm._v("My Last Duchess ")]), _vm._v("and "), _c('I', [_vm._v("The Fortune Hunter")]), _vm._v(", as well as the screenplay for Masterpiece’s Victoria on PBS. She has three dogs, two children, and a husband. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Oho3Mu/tc-custom/9780062031716.jpg?1731726885450",
      "alt": "This image is the cover for the book Essential Poems (To Fall in Love With)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Essential Poems (To Fall in Love With)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Forget chocolate, exotic lingerie, or marriage counselors -- the only props you'll ever need, whether you are in love or out of it, are the poems in this book. There are verses here to console you when the phone doesn't ring or the divorce papers have been signed, and poems that celebrate the joy of being in love, from the first kiss to walking down the aisle (for the second time). These essential poems, which include never-before-anthologized works, will tell you the truth about love.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollinsPublishers\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0